import { createSelector } from 'reselect';
import { ENG } from 'src/constants/languages';
import { getLanguageByAppFormat } from 'src/translations/tools';
const getReducer = (state) => state.translation;
export const selectLocale = createSelector(getReducer, ({ locale }) => locale || ENG.appFormat);
export const selectDayjsLocale = createSelector(selectLocale, (locale) => getLanguageByAppFormat(locale).iso6391);
